// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"c6a0b58e","160":"5fa827a6","208":"17dcb0a0","293":"052ed4d3","516":"e3c5e719","519":"6f04bcf0","917":"c5223b26","946":"57c0740a"}[chunkId] + ".chunk.js";
};